import { http } from '@/http/axios.js'
// 地址树
export function getAgentList() {
    return http({
        url: '/api/admin/pos-data/agent/list',
        method: 'GET',
    })
}
